module.exports = ".centro-texto {\n  translate: 10%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/productos-buscados/productos-buscados.component.scss
// module id = ./src/app/productos/productos-buscados/productos-buscados.component.scss
// module chunks = main